import { HostAPI } from "API/hostApi";
import { IMatchesEnum, TModeMatch } from "interfaces/intarfaces";
import { API_MATCHES } from "./constants";

const modeHandle: { [keyProp in TModeMatch]: string } = {
  acceptInvite: API_MATCHES + "invite",
  rejectInvite: API_MATCHES + "cancel-invite",
  removeMatch: API_MATCHES + "remove-match",
};

export const handleMatch = (
  mode: TModeMatch,
  payload: IMatchesEnum
): Promise<number> => {
  return new Promise((resolve, reject) => {
    HostAPI.post(modeHandle[mode], payload)
      .then((response) => {
        if (response.hasOwnProperty("status")) {
          resolve(response.status);
        } else if (response.hasOwnProperty("success") && response.success) {
          resolve(200);
        }
      })
      .catch(() => reject(400));
  });
};
